document.addEventListener("DOMContentLoaded", function () {
  const heroSections = document.querySelectorAll(".mimosa-hero");
  const ritualSections = document.querySelectorAll(".mimosa-ritual");
  const disciplinesSections = document.querySelectorAll(".mimosa-disciplines");
  const experienceSections = document.querySelectorAll(".mimosa-experience");

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function updateHeroScrollEffects() {
    heroSections.forEach((hero) => {
      const rect = hero.getBoundingClientRect();
      const heroHeight = hero.offsetHeight || window.innerHeight;
      const progress = clamp((-rect.top) / (heroHeight * 0.9), 0, 1);

      const content = hero.querySelector(".mimosa-hero__content");
      const image = hero.querySelector(".mimosa-hero__image");
      const overlay = hero.querySelector(".mimosa-hero__overlay");

      const contentOpacity = 1 - progress * 1.15;
      const contentTranslate = progress * 40;
      const imageOpacity = 1 - progress * 1.05;
      const imageScale = 1 - progress * 0.05;
      const overlayOpacityBase =
        parseFloat(
          getComputedStyle(hero).getPropertyValue("--mimosa-overlay-opacity")
        ) || 0;
      const overlayOpacity =
        overlayOpacityBase + progress * (1 - overlayOpacityBase);

      if (content) {
        content.style.opacity = String(clamp(contentOpacity, 0, 1));
        content.style.transform = `translate3d(0, ${contentTranslate}px, 0)`;
      }

      if (image) {
        image.style.opacity = String(clamp(imageOpacity, 0, 1));
        image.style.transform = `scale(${imageScale})`;
      }

      if (overlay) {
        overlay.style.opacity = String(clamp(overlayOpacity, 0, 1));
      }
    });
  }

  function initRevealSections(sectionSelector, itemSelector, threshold = 0.35, delay = 180) {
    const sections = document.querySelectorAll(sectionSelector);

    sections.forEach((section) => {
      const items = section.querySelectorAll(itemSelector);
      if (!items.length) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              items.forEach((item, index) => {
                setTimeout(() => {
                  item.classList.add("is-visible");
                }, index * delay);
              });
            } else {
              items.forEach((item) => {
                item.classList.remove("is-visible");
              });
            }
          });
        },
        { threshold: threshold }
      );

      observer.observe(section);
    });
  }

  let ticking = false;

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateHeroScrollEffects();
        ticking = false;
      });
      ticking = true;
    }
  }

  updateHeroScrollEffects();
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", updateHeroScrollEffects);

  if (ritualSections.length) {
    initRevealSections(".mimosa-ritual", ".js-ritual-line", 0.35, 220);
  }

  if (disciplinesSections.length) {
    initRevealSections(".mimosa-disciplines", ".js-disciplines-reveal", 0.18, 130);
  }

  if (experienceSections.length) {
    initRevealSections(".mimosa-experience", ".js-experience-reveal", 0.18, 120);
  }
});